
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import Axios from "axios";
import { API_STORE } from "@/config";
import { getAPIAuthorizedHeader } from "@/services/common";

@Component
export default class UploaderComponent extends Vue {
  public formData = new FormData();
  public files: any = new Array(File);
  public accept = ".png, .jpg, .jpeg,";
  public oldImageInfo = [];
  public showAdharCardError = false;
  public showPanCardError = false;
  public disableSubmitbutton = false;

  get imageFile() {
    return this.$store.state.imageFile;
  }

  get panCardImageSrc() {
    return this.$store.state.panCardImageSrc;
  }

  get adharCardImageSrc() {
    return this.$store.state.adharCardImageSrc;
  }
  get documents() {
    return this.$store.state.documents;
  }

  async fileChangeEvent(event, categoryName) {
    categoryName == "panCard"
      ? (this.showPanCardError = false)
      : (this.showAdharCardError = false);
    let file = event.target.files[0];
    file["categoryName"] = categoryName + "." + file.name.split(".").pop();
    let fieldName =
      categoryName == "panCard" ? "panCardImageSrc" : "adharCardImageSrc";
    this.imageFile.push(file);
    await this.$store.dispatch("updateStore", {
      [fieldName]: URL.createObjectURL(file),
      imageFile: this.imageFile,
    });
  }

  public async getUserDocuemtById() {
    if (this.documents.length > 0) {
      this.documents.forEach(async (doc) => {
        if (doc.categoryName == "panCard") {
          await this.$store.dispatch("updateStore", {
            panCardImageSrc:
              doc.fileHistory && doc.fileHistory.length > 0
                ? this.$AWS_S3_URL + doc.fileHistory[0].path
                : null,
          });
        } else if (doc.categoryName == "adharCard") {
          await this.$store.dispatch("updateStore", {
            adharCardImageSrc:
              doc.fileHistory && doc.fileHistory.length > 0
                ? this.$AWS_S3_URL + doc.fileHistory[0].path
                : null,
          });
        }
      });
    }
  }

  public async deleteImage(categoryName) {
    let fieldName =
      categoryName == "panCard" ? "panCardImageSrc" : "adharCardImageSrc";
    if (this.imageFile.length > 0) {
      this.imageFile.forEach((file, i) => {
        if (file.categoryName.startsWith(categoryName)) {
          let doc = this.documents.find(
            (a) =>
              a.categoryName == categoryName &&
              a.fileHistory &&
              a.fileHistory.length > 0
          );
          if (doc && !this.oldImageInfo.includes(doc.fileHistory[0].path)) {
            this.oldImageInfo.push(doc.fileHistory[0].path);
          }
          this.imageFile.splice(i, 1);
        }
      });
    }
    await this.$store.dispatch("updateStore", {
      [fieldName]: null,
      imageFile: this.imageFile,
    });
  }
  async saveInformation() {
    let valid = await this.$validator.validateAll();
    if (valid && this.panCardImageSrc && this.adharCardImageSrc) {
      if (this.$route.path == "/portal/updateProfile") {
        this.validateAndSubmit();
        this.$router.push("/portal");
      } else {
        if (this.$route.query.userId) this.validateAndSubmit();
        else {
        this.$emit("uploadPanAndAdhar", true);
        return { status: true };
        }
      }
    } else {
      if (!this.panCardImageSrc) this.showPanCardError = true;
      if (!this.adharCardImageSrc) this.showAdharCardError = true;
      return { status: false };
    }
  }

  async validateAndSubmit() {
    this.disableSubmitbutton = true;
    this.$showLoader(true);
    let formData = new FormData();
    for (let i = 0; i < this.imageFile.length; i++) {
      let file = this.imageFile[i];
      if (!file.categoryName.startsWith("profile"))
        formData.append("file", file, file.categoryName);
    }
    formData.append(
      "jsonData",
      JSON.stringify({ oldImageInfo: this.oldImageInfo })
    );
    let response = await Axios.post(
      API_STORE.COMMON + "uploadDocuments",
      formData,
      {
        params: {
          userId: this.$route.query.userId,
        },
        headers: getAPIAuthorizedHeader(),
      }
    );
    this.disableSubmitbutton = false;
    this.$showLoader(false);
    if (response) {
      this.$snotify.success(response.data.message);
      this.$emit("uploadPanAndAdhar", true);
    }
  }

  mounted() {
    this.getUserDocuemtById();
  }
}
